import { useMemo } from "react";
import { useStores } from "@hooks";
import { isProjectObserver, isProjectOwner } from "@utils";

export const useCheckProjectAccess = ( projectUsers = undefined ) => {
  const { userStore } = useStores();
  const {
    userId,
    userUuid,
    isAdmin,
    isManager,
    isBusinessUser,
    isMiniUser
  } = userStore;

  const isContractor = useMemo(
    () => {
      const contractorList = projectUsers?.contractor || projectUsers?.contractors || [];
      const isInContractorList = Boolean(
        userId &&
        contractorList.some((c) => c.id === userId)
      );

      return isInContractorList && !isProjectOwner(userId, projectUsers);
    },
    [userId, projectUsers]
  );

  const isOwner = useMemo(
    () => !isContractor && isProjectOwner(userId, projectUsers, isManager),
    [ isManager, isContractor, userId, projectUsers ]
  );

  const isObserver = useMemo(
    () => isProjectObserver(userId, projectUsers, isManager),
    [ isManager, userId, projectUsers ]
  );

  return {
    userUuid,
    userId,
    isOwner,
    isObserver,
    isContractor,

    isAdmin,
    isManager,
    isMiniUser,
    isBusinessUser,
  };
};
